import React, { forwardRef, useEffect, useState } from 'react'
import { getAllBillListing, uploadCheque } from '../../Redux/Actions/BillingsActions';
import { useDispatch, useSelector } from 'react-redux';
import { capitalizeFirstLetter, constructOptions } from '../../Utils/helper';
import Pagination from '../../Common/Pagination';
import Loader from '../../Common/Loader';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select'
import { getAddType, getProvider } from '../../Redux/Actions/DashOptions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCheckCircle, faClipboardCheck, faClockRotateLeft, faEye, faFile, faSpinner, faUpload } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Uploadgenrate from './BillingGenrate';
import axios from 'axios';

const MainBillingListing = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const ClientData = useSelector((state) => state?.BillingDataSlice?.getAllBillingData?.data)  // getting client info
    const ClienttDataLoading = useSelector((state) => state?.BillingDataSlice?.isLoading)  // laoding
    const getFilteredData = useSelector((state) => state?.BillingDataSlice?.getAllBillingData)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const { current_page, last_page, from, to, total } = useSelector((state) => state?.BillingDataSlice?.getAllBillingData)  // getting client info

    const getProviderData = useSelector((state) => state?.DashOptionsSlice?.listdata?.data) // get data for provider filter
    const getDataType = useSelector((state) => state?.DashOptionsSlice?.getTypeData?.data)

    const [page, setPage] = useState(current_page || 1) // set Page for pagination
    const [selectedDate, setSelectedData] = useState('')
    const [filters, setFilters] = useState({
        provider: null,
        type: null,
    });

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button
            onClick={onClick}
            ref={ref}
            className=" w-44 flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md bg-white shadow-sm text-sm font-medium text-gray-700 hover:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
            <FontAwesomeIcon icon={faCalendarDays} />
            {value ? value : "Select Month"}
        </button>
    ));
    const handleChangeMonth = (date) => {
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        setSelectedData(date); // Update selected date in state if needed
        dispatch(getAllBillListing({ month, year, page: page })).then((res) => {
            if (res?.type === 'get-all-billings/rejected') {
                toast.error('No billing records found for the given filters')
            }
        })
    };
const handleModalSubmit = async ({ file }) => {
        // Safeguard: Check if file exists and is valid
        if (!file || !file.name) {
            toast.error('No valid file selected.');
            return;
        }
    
        setSelectedFile(file); // Optional: Set state if needed elsewhere
    
        const formData = new FormData();
        formData.append("csv_file", file); // Use the passed file directly
    
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LARAVEL_API_URL}/import-billing-csv`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            
            console.log("Response:", response.data);
            toast.success('File uploaded successfully!'); // Or use response.data.message if available
            setIsModalOpen(false); // Close modal on success
            setSelectedFile(null); // Reset state
            // Optional: Refresh member list after upload
        
        } catch (error) {
            console.error("Upload error:", error);
            toast.error('Upload failed. Please try again.'); // Or error.response?.data?.message
        }
    };

    const handleClearFilter = () => {
        setSelectedData('')
        setFilters({
            provider: null,
            type: null,
        })
        dispatch(getAllBillListing({ page: page }));
    }

    const manageBillingData = (selectedId, selectedItem, getFilteredData) => {
        if (selectedItem?.status === 'new_member') {
            navigate(`/dashboard/newmemberbilling/${selectedId}`, {
                state: { billingData: selectedItem, pagination: { current_page: getFilteredData?.current_page, last_page: getFilteredData?.last_page, from: getFilteredData?.from, to: getFilteredData?.to, total: getFilteredData?.total } }
            });
        } else {
            navigate(`/dashboard/billing/${selectedId}`, {
                state: { billingData: selectedItem, pagination: { current_page: getFilteredData?.current_page, last_page: getFilteredData?.last_page, from: getFilteredData?.from, to: getFilteredData?.to, total: getFilteredData?.total } }
            });
        }
    }

    const handleUploadCheque = (e, selectedId) => {
        const formData = new FormData();
        const file = e.target.files[0];
        if (!file) {
            return
        }

        formData.append('billing_id', selectedId)
        formData.append('cheque_file', file)

        dispatch(uploadCheque(formData)).then((res) => {
            if (res?.type === "upload-cheque/fulfilled") {
                toast.success(res?.payload?.message)
            } else {
                toast.error('Error Occured')
            }
        })
    }
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedFile(null); // Reset file on close
    };
   
    const handleFilterChange = (key, selectedValue) => {
        const updatedFilters = {
            ...filters,
            [key]: selectedValue,
        };
        setFilters(updatedFilters);
        // Build payload only with selected filters
        const payload = {
            ...(updatedFilters.provider && { provider: updatedFilters.provider.value }),
            ...(updatedFilters.type && { type: updatedFilters.type.value }),
        };
        if (selectedDate) {
            const month = selectedDate.toLocaleString('en-US', { month: 'long' });
            const year = selectedDate.getFullYear();
            payload.month = month;
            payload.year = year;
        }
        dispatch(getAllBillListing(payload)).then((res) => {
            if (res?.type === 'get-all-billings/rejected') {
                toast.error('No billing records found for the given filters')
            }
        })
    };

    const handleViewPage = (selectedId, selectedItem, getFilteredData) => {
        if (selectedItem?.status === 'new_member') {
            navigate(`/dashboard/newmemberbilling/${selectedId}?mode=view`, {
                state: { billingData: selectedItem, pagination: { current_page: getFilteredData?.current_page, last_page: getFilteredData?.last_page, from: getFilteredData?.from, to: getFilteredData?.to, total: getFilteredData?.total } }
            });
        } else {
            navigate(`/dashboard/billing/${selectedId}?mode=view`, {
                state: { billingData: selectedItem, pagination: { current_page: getFilteredData?.current_page, last_page: getFilteredData?.last_page, from: getFilteredData?.from, to: getFilteredData?.to, total: getFilteredData?.total } }
            });
        }
    }

    const handleHistoryPage = (selectedId, selectedItem, getFilteredData) => {
        navigate(`/dashboard/history/${selectedId}`, {
            state: { billingData: selectedItem, pagination: { current_page: getFilteredData?.current_page, last_page: getFilteredData?.last_page, from: getFilteredData?.from, to: getFilteredData?.to, total: getFilteredData?.total } }
        })

    }

    const handleViewCheque = (selectedId, selectedItem, getFilteredData) => {
        navigate(`/dashboard/process/${selectedId}`, {
            state: { billingData: selectedItem, pagination: { current_page: getFilteredData?.current_page, last_page: getFilteredData?.last_page, from: getFilteredData?.from, to: getFilteredData?.to, total: getFilteredData?.total } }
        })

    }

    const handleReviewCheckDetails = (selectedID) => {
        navigate(`/dashboard/viewchequedetails/${selectedID}`)
    }

    const handleUploadNavigate = () => {
        navigate(`/dashboard/addcheque`)
    }

    useEffect(() => {
        dispatch(getAllBillListing({ page: page }));
        dispatch(getProvider());
        dispatch(getAddType());
    }, [page])

    return (
        <div>
            {ClienttDataLoading && <Loader />}
            <div className="pt-3 px-2 pb-6 bg-gray-100 min-h-screen w-full font-sans">
                <div className=" mx-auto bg-white rounded-lg shadow-md overflow-hidden">
                    <div className="p-4 flex items-center justify-between">
                        <h2 className="text-2xl font-semibold text-gray-800">Medicaid Billing</h2>
                        {/* New Blue Button on the Right */}
                        <button onClick={openModal}
                            className="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-medium text-sm text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200">
                            Generate
                        </button>
                    </div>
                    <div className="flex items-center justify-start mb-2 px-4 gap-2  w-full">
                        {/* <label className="block text-sm font-medium text-gray-700 mb-1">Filter By Month</label> */}
                        <Select
                            placeholder="Select Provider"
                            options={constructOptions(getProviderData?.filter(p => p?.status === 'active'), "id", "name")}
                            className="react-select-container text-sm"
                            classNamePrefix="react-select"
                            onChange={(e) => handleFilterChange("provider", e)}
                            value={filters.provider}
                        />
                        <Select
                            placeholder="Select Type"
                            options={constructOptions(getDataType?.filter(p => p?.status === 'active'), "id", "name")}
                            className="react-select-container text-sm"
                            classNamePrefix="react-select"
                            onChange={(e) => handleFilterChange("type", e)}
                            value={filters.type}
                        />
                        <div>
                            <DatePicker
                                selected={selectedDate}
                                showMonthYearPicker
                                dateFormat="MMMM yyyy"
                                customInput={<CustomInput />}
                                onChange={(e) => handleChangeMonth(e)}
                            />
                        </div>
                        {(selectedDate || filters.provider || filters.type) && (
                            <button onClick={handleClearFilter}
                                className="inline-flex items-center px-4 py-2 border border-indigo-300 shadow-sm text-sm font-medium rounded-md text-indigo-700 bg-indigo-50 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >Clear</button>
                        )}
                    </div>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Client
                                        Name
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Month
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        year
                                    </th>
                                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Provider
                                    </th>
                                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Type
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Status
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Amount Due
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Total Paid
                                    </th>
                                    {/* {statusForCheq?.some(status => status === "filing_done") && (
                                        <th scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            Upload Cheque
                                        </th>
                                    )} */}

                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        <div className="flex items-center">
                                            Filling
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="ml-1 h-3 w-3 text-gray-400"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Action
                                    </th>

                                </tr>
                            </thead>

                            <tbody className="bg-white divide-y divide-gray-200">
                                {!ClientData && !ClientData?.length > 0 ? (
                                    // getFilteredData?.map((item, index) => {
                                    //     return (
                                    <tr >
                                        <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-900">{capitalizeFirstLetter(getFilteredData?.client?.name)}</td>
                                        <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(getFilteredData?.month)}</td>
                                        <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">{getFilteredData?.year}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(getFilteredData?.provider?.name) || "--"}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(getFilteredData?.type?.name) || "--"}</td>
                                        <td className="px-3 py-3 whitespace-nowrap text-sm font-medium text-center">
                                            <span className={`px-2 py-1 rounded-full text-xs font-semibold 
    ${getFilteredData?.status === "open"
                                                    ? "text-green-700 bg-green-100"
                                                    : "text-red-700 bg-red-100"}`}>
                                                {capitalizeFirstLetter(getFilteredData?.status)}
                                            </span>
                                        </td>
                                        <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">${getFilteredData?.total_due}</td>
                                        <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">${getFilteredData?.total_paid}</td>
                                        <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                                            <button onClick={() => manageBillingData(getFilteredData?.id)}
                                                className="inline-flex items-center px-3 py-1 border border-indigo-300 shadow-sm text-sm font-medium rounded-md text-indigo-700 bg-indigo-50 hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                            >
                                                Filling
                                            </button>
                                        </td>
                                    </tr>
                                    //     )
                                    // })
                                ) : (
                                    <>
                                        {ClientData && ClientData?.map((item, index) => {

                                            return (

                                                <tr key={index}>
                                                    <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-900">{capitalizeFirstLetter(item?.client?.name)}</td>
                                                    <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(item?.month)}</td>
                                                    <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{item?.year}</td>
                                                    <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(item?.provider?.name) || "--"}</td>
                                                    <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(item?.type?.name) || "--"}</td>
                                                    <td className="px-3 py-3 whitespace-nowrap text-sm font-medium text-center">
                                                        <span
                                                            className={`px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${{
                                                                ready_for_filling: "text-indigo-700 bg-indigo-100",
                                                                filling: "text-blue-700 bg-blue-100",
                                                                done: "text-green-700 bg-green-100",
                                                                open: "text-yellow-700 bg-yellow-100",
                                                                uploaded: "text-teal-700 bg-teal-100",
                                                                review_cheque_details: "text-teal-700 bg-teal-100",
                                                                processing_cheque: "text-orange-700 bg-orange-100 animate-pulse",
                                                            }[item?.status.toLowerCase()] || "text-gray-700 bg-gray-100"
                                                                }`}
                                                        >
                                                            {item?.status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">${item?.total_due}</td>
                                                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">${item?.total_paid}</td>
                                                    {/* <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                                                        {item?.status === "filing_done" ? (
                                                            <label
                                                                className="inline-flex items-center justify-center px-2 py-1  w-33 justify-center rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-indigo-600 shadow-md hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 ease-in-out cursor-pointer"
                                                            >
                                                                <FontAwesomeIcon icon={faUpload} className='mr-2' /> <span>Upload</span>
                                                                <input
                                                                    type="file"
                                                                    className="hidden"
                                                                    accept=".pdf,.jpg,.png"
                                                                    onChange={(e) => handleUploadCheque(e, item?.id)}
                                                                />
                                                            </label>
                                                        ) : item?.status === "processing_cheque" ? (
                                                            <span className="inline-flex items-center justify-center px-2 py-1  w-33 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-yellow-500 to-yellow-600 shadow-md animate-pulse">
                                                                <FontAwesomeIcon icon={faSpinner} className='mr-2' />
                                                                Pending
                                                            </span>
                                                        ) : item?.status === "cheque_uploaded" ? (
                                                            <span className="inline-flex items-center justify-center px-2 py-1  w-30 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-green-500 to-green-600 shadow-md">
                                                                <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                                                                Uploaded
                                                            </span>
                                                        ) : null}
                                                    </td> */}
                                                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                                                        {/* {item?.status === "review_cheque_details" ? (
                                                            <button
                                                                onClick={() => handleReviewCheckDetails(item?.id)}
                                                                className="inline-flex items-center gap-2 justify-center px-2 py-1 w-100 border border-yellow-300 shadow-sm text-sm font-medium rounded-md text-yellow-700 bg-yellow-50 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                                                            >
                                                                <FontAwesomeIcon icon={faClipboardCheck} />
                                                                Review Cheque Details
                                                            </button>
                                                        ) :  */}
                                                        {item?.status === "filling" || item?.status === "uploaded" ? (
                                                            <>
                                                                {/* {item?.cheque_processed !== 0 || item?.status === "uploaded" ? (
                                                                    <button
                                                                        onClick={() => handleViewCheque(item?.id, item, getFilteredData)}
                                                                        className="ml-2 inline-flex items-center gap-2 justify-center px-2 py-1 w-100 border border-green-300 shadow-sm text-sm font-medium rounded-md text-green-700 bg-green-50 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                                                                    >
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                        View & Process Cheque
                                                                    </button>
                                                                ) : ( */}
                                                                <label onClick={handleUploadNavigate} className="inline-flex items-center justify-center px-2 py-1 w-100 justify-center rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-indigo-600 shadow-md hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 ease-in-out cursor-pointer">
                                                                    <FontAwesomeIcon icon={faUpload} className="mr-2" /> <span>Upload Cheque</span>
                                                                    {/* <input
                                                                            type="file"
                                                                            className="hidden"
                                                                            accept=".pdf,.jpg,.png"
                                                                            onChange={(e) => handleUploadCheque(e, item?.id)}
                                                                        /> */}
                                                                </label>
                                                                {/* )} */}
                                                            </>
                                                        ) : (
                                                            <button
                                                                onClick={() => manageBillingData(item?.id, item, getFilteredData)}
                                                                disabled={
                                                                    item?.status === "done" ||
                                                                    item?.status === "processing_cheque"
                                                                }
                                                                className={`inline-flex items-center gap-2 justify-center px-2 py-1 w-100 border border-indigo-300 shadow-sm text-sm font-medium rounded-md text-indigo-700 bg-indigo-50 
  ${item?.status === "processing_cheque" || item?.status === "done"
                                                                        ? "opacity-60 cursor-not-allowed"
                                                                        : "hover:bg-indigo-100"
                                                                    } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}

                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        item?.status === "processing_cheque"
                                                                            ? faSpinner
                                                                            : item?.status === "done"
                                                                                ? faCheckCircle
                                                                                : faFile
                                                                    }
                                                                    spin={item?.status === "processing_cheque"}
                                                                />
                                                                {item?.status === "processing_cheque"
                                                                    ? "Processing"
                                                                    : item?.status === "done"
                                                                        ? "Completed"
                                                                        : "Filling"}
                                                            </button>
                                                        )}
                                                    </td>
                                                    <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">
                                                        <div className='flex gap-3 items-center'>
                                                            <button onClick={() => handleViewPage(item?.id, item, getFilteredData)}
                                                                className="text-blue-600 hover:text-blue-900" title='view'><FontAwesomeIcon icon={faEye} className="text-blue-600" /></button>
                                                            {(item?.status === 'done' || item?.status === "filling") && (
                                                                <button
                                                                    onClick={() => handleHistoryPage(item?.id, item, getFilteredData)}
                                                                    type="button"
                                                                    className="inline-flex items-center px-2 py-1 text-xs font-medium text-white bg-yellow-500 hover:bg-yellow-600 rounded-md shadow-sm transition-all duration-200"
                                                                    title="History"
                                                                >
                                                                    <FontAwesomeIcon icon={faClockRotateLeft} className="mr-1" />
                                                                    History
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>

                                                </tr>
                                            )

                                        })}
                                    </>
                                )}

                            </tbody>
                        </table>
                        <div className="px-6 border-t border-gray-200 flex items-center justify-between mt-4">
                            <div className="flex-1 flex justify-between sm:hidden">
                                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">Previous</a>
                                <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">Next</a>
                            </div>
                            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between pb-4 mt-4">
                                <div>
                                    <p className="text-sm text-gray-700">
                                        Showing <span className="font-medium">{from}</span> to <span className="font-medium">{to}</span> of <span className="font-medium">{total}</span> results
                                    </p>
                                </div>
                                <div>
                                    <Pagination
                                        count={last_page}  // total pages
                                        page={page}         // current page
                                        onPageChange={handlePageChange}  // handler
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Uploadgenrate isOpen={isModalOpen} onClose={closeModal} onSubmit={handleModalSubmit} />
            

        </div>
    )
}

export default MainBillingListing
